import { useEffect, useState } from 'react';

// Avviso comune per deadlock e timeout del database (risposta 409/503 con codice RIPROVA): "il sistema è occupato, riprova".
// Lo mostra Layout, e lo accende l'interceptor di api.js con l'evento `hub-riprova`; sparisce da solo. Non apre la finestra
// Ricarica/Sovrascrivi (che è solo per CONFLITTO_VERSIONE): i dati inseriti nei moduli restano dove sono.
export default function AvvisoRiprova() {
  const [messaggio, setMessaggio] = useState('');
  useEffect(() => {
    let timer;
    const mostra = (e) => {
      setMessaggio(e.detail || 'Il sistema è occupato: riprova tra qualche secondo.');
      clearTimeout(timer);
      timer = setTimeout(() => setMessaggio(''), 8000);
    };
    window.addEventListener('hub-riprova', mostra);
    return () => { window.removeEventListener('hub-riprova', mostra); clearTimeout(timer); };
  }, []);
  if (!messaggio) return null;
  return (
    <div role="alert" style={{ position: 'fixed', top: 12, left: '50%', transform: 'translateX(-50%)', zIndex: 3000, background: '#fff7ed', color: '#9a3412',
      border: '1px solid #fdba74', borderRadius: 8, padding: '0.6rem 1rem', boxShadow: '0 2px 8px rgba(0,0,0,0.15)', maxWidth: '90vw', fontSize: '0.92rem' }}>
      {messaggio}
      <button type="button" onClick={() => setMessaggio('')} aria-label="Chiudi l'avviso" style={{ marginLeft: '0.8rem', border: 'none', background: 'transparent', cursor: 'pointer', color: '#9a3412', fontSize: '1rem' }}>×</button>
    </div>
  );
}
